module.exports = {
      id: "bookmark-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#bookmark",
      toString: function () {
        return this.url;
      }
    }